import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
} from "@chakra-ui/react";

export interface RenameModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  label?: string;
  placeholder?: string;
  name: string;
  onNameChange: (name: string) => void;
  onConfirm: () => void | Promise<void>;
  isLoading?: boolean;
}

const RenameModal: React.FC<RenameModalProps> = ({
  isOpen,
  onClose,
  title = "Rename",
  label = "Name",
  placeholder = "Enter new name",
  name,
  onNameChange,
  onConfirm,
  isLoading,
}) => (
  <Modal isOpen={isOpen} onClose={onClose} isCentered>
    <ModalOverlay backdropFilter="blur(4px)" />
    <ModalContent borderRadius="xl" mx={4}>
      <ModalHeader>{title}</ModalHeader>
      <ModalCloseButton />
      <ModalBody pb={6}>
        <FormControl>
          <FormLabel fontSize="sm" fontWeight="600" color="gray.700">
            {label}
          </FormLabel>
          <Input
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder={placeholder}
            size="lg"
            onKeyDown={(e) => {
              if (e.key === "Enter" && name.trim()) onConfirm();
            }}
            _focus={{
              borderColor: "purple.400",
              boxShadow: "0 0 0 1px var(--chakra-colors-purple-400)",
            }}
          />
        </FormControl>
      </ModalBody>
      <ModalFooter>
        <Button variant="ghost" mr={3} onClick={onClose} isDisabled={isLoading}>
          Cancel
        </Button>
        <Button
          colorScheme="purple"
          onClick={onConfirm}
          isDisabled={!name.trim()}
          isLoading={isLoading}
        >
          Rename
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default RenameModal;
